import { component$ } from "@builder.io/qwik";
import { routeLoader$ } from "@builder.io/qwik-city";
import { NotFoundPage } from "~/components/pages/not-found";

export const useStatus = routeLoader$(({ status }) => {
  status(410);
});

export default component$(() => {
  useStatus();
  return <NotFoundPage />;
});
